import {Route} from "@angular/router";
import {guardOrganizationWatch} from "@/app/routes/guards/organizations-guard";

const NAME = 'Организации';

export const organizations: Route[] = [
    {
        path: 'organization',
        loadComponent: () => import('@components/guides/organization/organization.component').then(c => c.OrganizationComponent),
        canActivate: [guardOrganizationWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'organization/:id',
        loadComponent: () => import('@components/guides/organization/organization-details/organization-details.component').then(c => c.OrganizationDetailsComponent),
        canActivate: [guardOrganizationWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/organization/'},
            ]
        }
    },
]
